import { FilterState } from '../../../../containers/applicant_tracking/Analytics/Filters';
import { Funnel } from '../../../../entities/applicant_tracking/analytics/Funnel';
import { ApiService } from '../../../ApiService';
import { mapToParams } from '../mapToParams';

export class FunnelService {
  public static show(
    filterState?: FilterState,
    signal?: AbortSignal,
    startStageId?: number,
    endStageId?: number,
  ): Promise<Funnel> {
    const params = {
      ...mapToParams(filterState),
      ...(startStageId != null && { start_stage_id: startStageId }),
      ...(endStageId != null && { end_stage_id: endStageId }),
    };

    return ApiService.get(
      '/api/v1/applicant_tracking/analytics/funnel',
      params,
      { signal },
    );
  }
}
